import { BaseFetch } from "../main-model"
export default class TraditionModel extends BaseFetch {
  getTraditionBy = (data) =>
    this.authFetch({
      url: "tradition/getTraditionBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTraditionById = (data) =>
    this.authFetch({
      url: "tradition/getTraditionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateTraditionById = (data) =>
    this.authFetch({
      url: "tradition/updateTraditionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertTradition = (data) =>
    this.authFetch({
      url: "tradition/insertTradition",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteTraditionById = (data) =>
    this.authFetch({
      url: "tradition/deleteTraditionById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
